/**
 * Prefer a non-empty, content-rich aggregate_summary when coalescing API buckets.
 * An empty `{}` at results.aggregate_summary must not hide collection_results.bias[0].aggregate_summary.
 */

export function isRichAggregateSummary(s: unknown): boolean {
  if (!s || typeof s !== 'object' || Array.isArray(s)) return false;
  const o = s as Record<string, unknown>;
  const nonEmptyObj = (x: unknown) =>
    x != null && typeof x === 'object' && !Array.isArray(x) && Object.keys(x as object).length > 0;
  return !!(
    nonEmptyObj(o.avg_metrics) ||
    nonEmptyObj(o.audit_avg_metrics) ||
    nonEmptyObj(o.audited_avg_metrics) ||
    nonEmptyObj(o.sensitive_density) ||
    nonEmptyObj(o.sensitive_by_source) ||
    nonEmptyObj(o.attribute_mentions) ||
    nonEmptyObj(o.verdict_distribution) ||
    nonEmptyObj(o.funnel) ||
    o.microeai_bias_score != null
  );
}

/** First candidate that looks like a real bias aggregate; otherwise first non-empty object. */
export function pickBestAggregateSummary(candidates: unknown[]): Record<string, unknown> | undefined {
  const nonEmpty = candidates.filter((s): s is Record<string, unknown> => {
    if (s == null || typeof s !== 'object' || Array.isArray(s)) return false;
    return Object.keys(s as object).length > 0;
  });
  const rich = nonEmpty.find(isRichAggregateSummary);
  if (rich) return rich;
  return nonEmpty[0];
}
